/**
 * defa.views.InvoiceContainer
 * A container for invoice handling.
 * @version 1.2.1
 */
import Usage             from 'scripts/defa/invoices/model-usage';
import InvoiceUpdateForm from 'scripts/defa/invoices/view-invoice-update-form';
import UsageCreateForm   from 'scripts/defa/invoices/view-usage-create-form';
import Container         from 'scripts/poppet/container';
import template          from 'templates/invoiceContainer.jst.html';

const channelNav = Bb.Radio.channel( 'nav' );

const selectors = {
	regionContainer: '[data-region=invoice-container]',
	regionCreate   : '[data-region=invoice-create]',
};

const InvoiceContainer = Container.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.regionContainer,
		create   : selectors.regionCreate,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView requests to create a new usage.
	 * @void
	 */
	onChildviewCreateUsage: function () {
		this._createUsage();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches the base invoice form.
	 * @void
	 */
	attachView: function () {
		
		this.invoiceUpdateForm = new InvoiceUpdateForm( _.extend( this.options, {
			model: this.options.invoice,
		} ) );
		this.showChildView( 'container', this.invoiceUpdateForm );
	},
	
	/**
	 * Creates a new usage on the existing invoice.
	 * @void
	 */
	_createUsage: function () {
		
		let usage           = new Usage(),
			usageCreateForm = new UsageCreateForm( _.extend( this.options, {
				model: usage,
			} ) );
		
		this.listenToOnce( usage, 'sync', function () {
			
			this.invoiceUpdateForm.busy();
			usageCreateForm.animateOut( false );
			
			channelNav.trigger( 'invoice:update', [ usage.get( 'invoice' ), ], { refresh: true, trigger: true } );
			
		} );
		
		this.showChildView( 'create', usageCreateForm );
	},
	
} );

export default InvoiceContainer;